export default __webpack_public_path__ + "assets/default_playlist.png";